/**
 * AccessHub catalog runtime for this app.
 * model_selector on → GpuBrowser; off → AccessHub Pick dump_id.
 */
import { useEffect, useState } from "react";
import {
  fetchPrimaryRuntime,
  gpuBrowserOn,
  type CatalogRuntime,
} from "@forgesuite/gpu-browser";

export function useCatalogRuntime(app: string): {
  selectorOn: boolean | null;
  runtime: CatalogRuntime | null;
} {
  const [selectorOn, setSelectorOn] = useState<boolean | null>(null);
  const [runtime, setRuntime] = useState<CatalogRuntime | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchPrimaryRuntime(app)
      .then((rt) => {
        if (cancelled) return;
        setRuntime(rt);
        setSelectorOn(gpuBrowserOn(rt));
      })
      .catch(() => {
        if (cancelled) return;
        setSelectorOn(true);
      });
    return () => {
      cancelled = true;
    };
  }, [app]);

  return { selectorOn, runtime };
}
